export class UserMenuHandler {
    $nextTick: (callback: () => void) => void;
    $root: HTMLElement;
    $refs: Record<string, HTMLElement>;
    open = false;

    toggle() {
        this.open ? this.close() : this.openAndFocusFirst();
    }

    openAndFocusFirst() {
        this.open = true;
        this.$nextTick(() => this.focusAt(0));
    }

    close() {
        this.open = false;
    }

    init() {
        this.$root.__close = this.close.bind(this);
    }

    items() {
        return Array.from(this.$refs.items?.querySelectorAll('[role="menuitem"]') || []);
    }

    move(delta) {
        const els = this.items();
        if (!els.length) return;
        let i = els.indexOf(document.activeElement);
        if (i === -1) i = 0;
        els[(i + delta + els.length) % els.length].focus();
    }

    focusAt(idx) {
        const els = this.items();
        if (!els.length) return;
        const n = idx < 0 ? els.length - 1 : Math.min(idx, els.length - 1);
        els[n].focus();
    }
}
